import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ConfirmRevertDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  entityLabel: string;
  onConfirm: () => void;
  isPending: boolean;
}

export function ConfirmRevertDialog({
  open,
  onOpenChange,
  entityLabel,
  onConfirm,
  isPending,
}: ConfirmRevertDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Revert to draft?</DialogTitle>
          <DialogDescription>
            This will move the {entityLabel} back to draft so it can be edited.
            Activity is preserved and the change is recorded in the audit log.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isPending}>
            {isPending ? "Reverting..." : "Revert to draft"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
